"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.SYNC_CONFIGS, (table)=>{
        table.string('created_by', 20);
        table.string('updated_by', 20);
        table.text('meta'); // JSON field
    });
};
const down = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.SYNC_CONFIGS, (table)=>{
        table.dropColumn('created_by');
        table.dropColumn('updated_by');
        table.dropColumn('meta');
    });
};
